import { specialistsGetTop } from '@services/specialists';
import { topSpecialistsReceiveGetList } from '@slices/top-specialists';
import { TopSpecialistsFetchGetList } from './types';
export const topSpecialistsFetchGetList: TopSpecialistsFetchGetList = payload => {
  return async dispatch => {
    const data = await specialistsGetTop(payload).promise;
    dispatch(topSpecialistsReceiveGetList({
      specialistList: {
        ...payload,
        ...data
      }
    }));
    return data;
  };
};